import { Link } from 'react-router'
import { useQuery } from '@tanstack/react-query'
import { api, type ExportZeile } from '../lib/api'
import { zeitpunkt, zeitraum } from '../lib/format'
import { ExportLoeschen, herunterladen } from '../teile/Exportieren'
import { useAnmeldung } from '../lib/anmeldung'

const spalten = { gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.3fr) 130px 80px 90px 150px 170px' }

/** Alle erzeugten Dateien der Kanzlei, neueste zuerst. Jede laesst sich erneut herunterladen, bis die Loeschfrist greift. */
export function ExporteSeite() {
  const { auskunft } = useAnmeldung()
  const { data, isPending, error } = useQuery({
    queryKey: ['exporte'],
    queryFn: () => api.holen<{ exporte: ExportZeile[] }>('/api/exporte'),
  })

  return (
    <>
      <div className="liste">
        <div className="listenkopf" style={spalten}>
          <div>Mandant</div>
          <div>Datei</div>
          <div>Format</div>
          <div className="rechts">Auszüge</div>
          <div className="rechts">Buchungen</div>
          <div>Erzeugt</div>
          <div />
        </div>
        {isPending && <div className="laedt">Wird geladen …</div>}
        {error && <div className="leer"><strong>Die Exporte konnten nicht geladen werden.</strong></div>}
        {data && data.exporte.length === 0 && (
          <div className="leer">
            <strong>Noch nichts exportiert.</strong>
            <p>Exportiert wird beim Mandanten, sobald seine Auszüge geprüft sind.</p>
          </div>
        )}
        {data?.exporte.map((e) => (
          <div key={e.id} className="zeile" style={spalten}>
            <div>
              <Link to={`/mandanten/${e.mandant_id}`} className="sache verweis-still">{e.mandant_name}</Link>
              {e.mandantennummer ? <div className="nebensache zahl">{e.mandantennummer}</div> : null}
            </div>
            <div>
              <div className="leise klein-sache">{e.dateiname}</div>
              <div className="nebensache zahl">{zeitraum(e.zeitraum_von, e.zeitraum_bis)}</div>
            </div>
            <div className="leise">{e.format === 'camt053' ? `camt.053.001.${e.version}` : 'MT940'}</div>
            <div className="leiser zahl rechts">{e.anzahl_auszuege}</div>
            <div className="leiser zahl rechts">{e.anzahl_buchungen}</div>
            <div>
              <div className="leiser zahl">{zeitpunkt(e.erzeugt_am)}</div>
              {e.erzeugt_von && <div className="nebensache">{e.erzeugt_von}</div>}
            </div>
            <div className="zeilenaktionen">
              <button type="button" className="knopf klein" onClick={() => herunterladen(e.id)}>Herunterladen</button>
              <ExportLoeschen exportId={e.id} dateiname={e.dateiname} />
            </div>
          </div>
        ))}
      </div>
      {auskunft?.loeschfristTage && (
        <p className="leiser abstand-oben">Exporte und Originale werden {auskunft.loeschfristTage} Tage nach dem Export gelöscht. Einstellbar im Profilmenü.</p>
      )}
    </>
  )
}
